import React from 'react';
import { Navigate } from 'react-router-dom';

import { MATERIAL_MANAGEMENT_FEATURE_FLAG } from 'core/service/feature-flag/feature-flag.constants';
import FeatureFlagGuard from 'core/auth/feature-flag-guard.component';
import { linkRoutes } from 'core/routes/routes';
import { lotsModulePaths } from './routes/lots.routes';

// eslint-disable-next-line react-refresh/only-export-components
const LotsScene = React.lazy(() => import('scenes/lots/lots.scene'));
// eslint-disable-next-line react-refresh/only-export-components
const LotDetailsScene = React.lazy(() => import('scenes/lot-details/lot-details.scene'));

export const lotsSidebar = [
    {
        path: lotsModulePaths.lots,
        element: (
            <FeatureFlagGuard featureFlag={MATERIAL_MANAGEMENT_FEATURE_FLAG} redirect={linkRoutes.root}>
                <LotsScene key="lots-active" />
            </FeatureFlagGuard>
        ),
    },
    {
        path: lotsModulePaths.lotsFilter,
        element: (
            <FeatureFlagGuard featureFlag={MATERIAL_MANAGEMENT_FEATURE_FLAG} redirect={linkRoutes.root}>
                <LotsScene key="lots-filter" />
            </FeatureFlagGuard>
        ),
    },
];

// Detail routes are kept out of the sidebar array (that array is for sidebar/nav entries).
// The full-screen Lot Detail page stays behind the AMM feature flag like every AMM route.
export const lotsDetailRoutes = [
    {
        path: lotsModulePaths.lotDetail,
        element: (
            <FeatureFlagGuard featureFlag={MATERIAL_MANAGEMENT_FEATURE_FLAG} redirect={linkRoutes.root}>
                <LotDetailsScene />
            </FeatureFlagGuard>
        ),
    },
];

export const lotsRedirectRoutes = [
    {
        path: lotsModulePaths.releasedLotsInactive,
        element: <Navigate to={lotsModulePaths.lotsInactive} replace />,
    },
];
